window.Branch = window.Branch || {};
window.Branch.addons = window.Branch.addons || {};

const standardizeTileHeight = function(addonElement){
    let tiles = addonElement.querySelectorAll('.item');
    tiles.forEach((tile) => {
      tile.style.removeProperty("height");
    });
    let greatestHeight = Math.max(...Array.from(tiles).map(el => el.offsetHeight));
    // console.log('greatestHeight', greatestHeight)

    tiles.forEach((tile) => {
      tile.style.height = `${greatestHeight}px`;
    })
  }

const updateTabsPosition = function(container){
    let totalWidth = Array.from(container.querySelectorAll('.addons__tabs-button')).reduce((total, el) => total + el.offsetWidth, 0);
    let index = parseInt(container.getAttribute('data-index-selected'));
    let innerContainer = container.querySelector('.addons__tabs-inner-container');
    let differenceIncrements = (totalWidth - container.offsetWidth) / container.querySelectorAll('.addons__tabs-button').length
    innerContainer.style.transform = index == 0 ? `translateX(0)` : `translateX(-${(index + 1) * differenceIncrements}px)`
}

const updateUnderlinePosition = function(container){
    let index = parseInt(container.getAttribute('data-index-selected'));
    let blueUnderline = container.querySelector('.addons__blue-underline');
    let translateAmount = 0;
    if(container.getAttribute('data-tabs-carousel') == 'true'){
      let addonButton = container.querySelectorAll('.addons__tabs-button ');
      addonButton.forEach((addonButton, addonButtonSpanIndex) => {
        if(addonButtonSpanIndex < index){
          translateAmount = translateAmount + addonButton.offsetWidth;
        }
      })
      translateAmount = `${translateAmount}px`
    } else {
      translateAmount = `${index * 100}%`;
    }
    blueUnderline.style.transform = `translateX(${translateAmount})`;
    blueUnderline.setAttribute('data-index', index);
} 


window.Branch.addons.addOnLifestyleOnHover = function(position, random_number){
  if(window.Branch.functions.isTouchDevice() == false && position == 'pdp'){
   
    /* Start of code to delete after test is complete */
    let testActive = document.querySelector('#addons-test-lifestyle-hover') && document.querySelector('#addons-test-lifestyle-hover').getAttribute('data-test-active') == 'true'
    if(testActive){
    /* End of code to delete after test is complete */
      
      let addonElement = document.querySelector(`.addons__container[data-id="${ random_number }"]`);
      let addonImages = addonElement.querySelectorAll('.addon-img');
      addonImages.forEach((addonImage) => {
        let srcSet = window.Branch.functions.returnSrcSet(addonImage.getAttribute('data-lifestyle-image-url'));
        let imageHTML = `<img draggable="false" src="${addonImage.getAttribute('data-lifestyle-image-url')}" class="addons_lifestyle-image" width="120" height="130" srcset="${srcSet}" sizes="(min-width: 900px) calc((450px - ((3.25 - 1) * 10px)) / 3.25), (min-width: 840px) calc((77.77vw - ((2.25 - 1) * 10px)) / 2.25), (min-width: 600px) calc(((100vw - 128px) - ((2.25 - 1) * 10px)) / 2.25), calc(((100vw - 48px) - ((2.25 - 1) * 10px)) / 2.25)" alt="${addonImage.querySelector('img').getAttribute('alt')}" loading="eager">`
          addonImage.insertAdjacentHTML('afterbegin', imageHTML);
 
        addonImage.setAttribute('data-lifestyle-image-inserted', true)
      });
    
    /* Start of code to delete after test is complete */
    }
    /* End of code to delete after test is complete */

  }
}

  window.Branch.addons.initAddonStyling = function(position, random_number, from){
    let addonElement = document.querySelector(`.addons__container[data-id="${ random_number }"]`);
    // console.log('addonElement', addonElement, from)
    if(addonElement && addonElement.querySelectorAll('.addons__inner-container .item.swiper-slide').length > 0){

      let fireStandardizeTileHeight = true;

      if(position != "side-cart" && addonElement.getAttribute('data-carousel-quantity') == '1'){
        if(parseInt(addonElement.querySelector('.addons').getAttribute('data-addons-length')) < 3){
          fireStandardizeTileHeight = false;
        }
      }

      // console.log('fireStandardizeTileHeight', fireStandardizeTileHeight)

      if(fireStandardizeTileHeight){
        standardizeTileHeight(addonElement);
      }

      let addonButtonSpans = addonElement.querySelectorAll('.addons__tabs-button span.addons__tabs-button-text');
      let underline = addonElement.querySelector('.addons__underline');
        addonButtonSpans.forEach((addonButtonSpan, index) => {
          addonButtonSpan.closest('.addons__tabs-button').style.paddingLeft = 0;
          addonButtonSpan.closest('.addons__tabs-button').style.paddingRight = 0;
        })
  
      let greatestWidth = Math.max(...Array.from(addonButtonSpans).map(el => el.offsetWidth));
      let totalWidth = (greatestWidth + (2 * 12)) * (addonButtonSpans.length)
      if(addonButtonSpans.length < 4 || totalWidth < addonElement.offsetWidth) {
        addonElement.setAttribute('data-tabs-carousel', false);
        addonElement.querySelector('.addons__tabs-inner-container').style.transform = 'translateX(0)';
  
        underline.style.width = '100%';
        underline.style.marginLeft = `0`
        addonButtonSpans.forEach((addonButtonSpan, index) => {
          addonButtonSpan.closest('.addons__tabs-button').style.width = `${100 / (addonButtonSpans.length)}%`;
          addonButtonSpan.closest('.addons__tabs-button').style.paddingLeft = '12px';
          addonButtonSpan.closest('.addons__tabs-button').style.paddingRight = '12px';
        })
      } else {
        addonElement.setAttribute('data-tabs-carousel', true)
        addonButtonSpans.forEach((addonButtonSpan, index) => {
          underline.style.width = `${(greatestWidth + (2 * 12)) * addonButtonSpans.length}px`;
          if(index == 0 && position == 'pdp'){
            addonButtonSpan.closest('.addons__tabs-button').style.width = `${greatestWidth + 12}px`;
            addonButtonSpan.closest('.addons__tabs-button').style.paddingLeft = '12px';
            addonButtonSpan.closest('.addons__tabs-button').style.paddingRight = '6px';
          } else if (index == (addonButtonSpans.length - 1) && position == 'pdp') {
            addonButtonSpan.closest('.addons__tabs-button').style.width = `${greatestWidth + 12}px`;
            addonButtonSpan.closest('.addons__tabs-button').style.paddingLeft = '6px';
            addonButtonSpan.closest('.addons__tabs-button').style.paddingRight = '12px';
          } else {
            addonButtonSpan.closest('.addons__tabs-button').style.width = `${greatestWidth + (2 * 12)}px`;
            addonButtonSpan.closest('.addons__tabs-button').style.paddingLeft = '12px';
            addonButtonSpan.closest('.addons__tabs-button').style.paddingRight = '12px';
          }
        })
        updateTabsPosition(addonElement);
      }
      addonElement.setAttribute('data-initialized', true);
  
      if (position == "side-cart"){
        let sideCartWrapper = addonElement.closest('.addons__side-cart-wrapper');
        let sideCartHeader = addonElement.closest('.cart-items').querySelector('.addons__side-cart-header-container');
        let open = sideCartHeader.getAttribute('data-open') == 'true';
        if(open == true){
          sideCartWrapper.style.height = `${addonElement.offsetHeight + 12}px`;
          sideCartWrapper.style.paddingTop = `0`;
          sideCartWrapper.style.paddingBottom = `12px`;
  
        } else {
          sideCartWrapper.style.height = `0`;
          sideCartWrapper.style.paddingTop = `4px`
          sideCartWrapper.style.paddingBottom = `0`;
        }
      }
    } else {
      if (addonElement && position == "side-cart"){
        addonElement.closest('.cart-items').querySelector('.addons__side-cart-header-container').setAttribute('data-hidden', true);
      }
    }
  }

  window.Branch.addons.initAddonSwipers = function (parent_selector, type, position, addonSwiperInstances, typesArray) {
    // Make selector more specific to avoid cross-contamination between pdp and side-cart
    const containerSelector = position === 'side-cart' 
      ? `${parent_selector} .addons__container.cart-addons .swiper[data-type="${type}"] .swiper-wrapper`
      : `${parent_selector} .addons__container:not(.cart-addons) .swiper[data-type="${type}"] .swiper-wrapper`;
    
    const swiperWrapper = document.querySelector(containerSelector);
    if(swiperWrapper){
      const addonsSection = swiperWrapper.closest('.swiper');
      const items = swiperWrapper.children.length;
      let autoplay = false;
      let oldStyleLessThanThree = false;

      if (type === 'original') {
          if (items < 3) {
              oldStyleLessThanThree = true;
          }
          if (position === 'side-cart') {
              oldStyleLessThanThree = true;
          }
      }

      if (items < 3 && typesArray.length < 2) {
          oldStyleLessThanThree = true;
      } else if (items < 3 && typesArray.length < 3 && typesArray.includes('original')) {
          oldStyleLessThanThree = true;
      }

      // Remove ALL existing headers first to prevent duplication
      const allHeadElements = addonsSection.querySelectorAll('.head');
      allHeadElements.forEach(element => element.remove());

      // Create a single header for side-cart recommended items
      if (position === 'side-cart' && type === 'recommended') {
          const headElement = document.createElement('div');
          headElement.className = 'head';
          headElement.setAttribute('aria-hidden', 'true');
          headElement.innerHTML = '<article>Accessories:</article><article class="addon_Count">' + items + ' item' + (items > 1 ? 's' : '') + '</article>';
          addonsSection.insertBefore(headElement, addonsSection.firstChild);
      } else {
          // For other cases, just update the count if a header exists
          const addonCountElement = addonsSection.querySelector('.addon_Count');
          if (addonCountElement) {
              addonCountElement.textContent = `${items} item${items > 1 ? 's' : ''}`;
          }
      }

      const autoplayAttr = addonsSection.getAttribute('data-autoplay');
      if (autoplayAttr === "true" && items > 3) {
          const autoplayDelay = parseInt(addonsSection.getAttribute('data-autoplay-delay'), 10) || 0;
          autoplay = {
              delay: autoplayDelay * 1000,
              disableOnInteraction: false
          };
      }

      const params = window.Branch.addons.returnAddonsParams(position, autoplay, parent_selector, type);

      if (!oldStyleLessThanThree) {
          // Use the same specific selector for Swiper initialization
          const swiperSelector = position === 'side-cart' 
            ? `${parent_selector} .addons__container.cart-addons .swiper[data-type="${type}"]`
            : `${parent_selector} .addons__container:not(.cart-addons) .swiper[data-type="${type}"]`;
          
          const addonsSwiper = new Swiper(swiperSelector, params);
          addonSwiperInstances.push(addonsSwiper);
      }
    } 
};

  window.Branch.addons.returnAddonsParams = function(position, autoplay, parent_selector, type){
    let params;

    if(position == 'pdp'){
        params = {
            slidesPerView: 2.25,
            spaceBetween: 10,
            freeMode: false,
            autoplay: autoplay,
            navigation: {
                nextEl: `${parent_selector} .addons-container[data-type="${type}"] .addons__nav-right.swiper-button-next`,
                prevEl: `${parent_selector} .addons-container[data-type="${type}"] .addons__nav-left.swiper-button-prev`,
            },
            breakpoints: {
                900: {
                  slidesPerView: 3.25,
                  spaceBetween: 10,
                  autoplay: autoplay,
                  allowTouchMove: true,
                  navigation: {
                    nextEl: `${parent_selector} .addons-container[data-type="${type}"] .addons__nav-right.swiper-button-next`,
                    prevEl: `${parent_selector} .addons-container[data-type="${type}"] .addons__nav-left.swiper-button-prev`,
                  }
                }
              },
              on: {
                init: function () {
                  
                }
              }
            }
    } else {
        params = {
            slidesPerView: 2.25,
            spaceBetween: 10,
            freeMode: false,
            autoplay: autoplay,
            navigation: {
                nextEl: `.cart-items .addons__nav-right[data-carousel-type="${type}"]`,
                prevEl: `.cart-items .addons__nav-left[data-carousel-type="${type}"]`,
            },
            on: {
              init: function () {

              }
            }
        }
    }
    return params;
  }

  window.Branch.addons.handleTabClick = function(e, direction, element){
    let button;
    if(e){
      e.preventDefault();
      button = e.target.closest('.addons__tabs-button');
    } else {
      let currentButton = element.closest('.addons__container').querySelector(`.addons__tabs-button[data-type="${element.closest('.addons__container').getAttribute('data-type-selected')}"]`);
      const sibling = direction === 'left' ? currentButton.nextElementSibling : currentButton.previousElementSibling;
      button = sibling && sibling.classList.contains(currentButton.className) ? sibling : currentButton;
    }
    if(button){
      let type = button.getAttribute('data-type');
      let indexSelected = button.getAttribute('data-index')
      let container = button.closest('.addons__container');
      container.setAttribute('data-type-selected', type);
      container.setAttribute('data-index-selected', indexSelected);
      updateUnderlinePosition(container)
      if(container.getAttribute('data-tabs-carousel') == 'true'){
        updateTabsPosition(container)
      }
    }
  }

  window.Branch.addons.handleButtonClick = function(e){
    e.preventDefault();
    let button = e.target.closest('.addons__side-cart-header-container');
    let newValue = button.getAttribute('data-open') == 'true' ? false : true;
    button.setAttribute('data-open', newValue);
    let container = button.closest('.cart-items').querySelector('.addons__container');
    let sideCartWrapper = container.closest('.addons__side-cart-wrapper');

    if(newValue == true){
      sideCartWrapper.style.height = `${container.offsetHeight + 12}px`;
      sideCartWrapper.style.paddingTop = `0`;
      sideCartWrapper.style.paddingBottom = `12px`;

    } else {
      sideCartWrapper.style.height = `0`;
      sideCartWrapper.style.paddingTop = `4px`;
      sideCartWrapper.style.paddingBottom = `0`
    }
  }

  const toggleDragListener = function(dragAllowed, addonElement) {
    const handleDragStart = (e) => {
        if (e.target.tagName === 'IMG') {
            e.preventDefault(); // Prevent dragging on images
        }
    };

    if (dragAllowed) {
        addonElement.removeEventListener('dragstart', handleDragStart);
        addonElement.setAttribute('data-drag-allowed', true);
    } else {
        addonElement.addEventListener('dragstart', handleDragStart);
        addonElement.setAttribute('data-drag-allowed', false);
    }
}

  window.Branch.addons.updateSwiperTouch = function(swipersArray, position, random_number){
    if(position == 'pdp'){
      let addonElement = document.querySelector(`.addons__container[data-id="${ random_number }"]`);
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth < 900;
      
      let allowDrag = isTouchDevice || isSmallScreen

      swipersArray.forEach((swiper) => {
        swiper.allowTouchMove = allowDrag;
      });

      toggleDragListener(allowDrag, addonElement)
    }
}
